import { gql, useMutation, useQuery } from '@apollo/client';
import { getWorkflowCompletionHeaders } from '@ovComponents/4-module/workflowCompletion/workflowCompletionHeaders';
import { useEffect, useState } from 'react';
import { RiskQuestionVisual } from './riskQuestion.visual';

const FETCH_USER = gql`
  query fetchUser($userId: SafeString!) {
    fetchUser(input: { userId: $userId }) {
      user {
        id: stringId
        riskQuestion1
        riskQuestion2
      }
    }
  }
`;

const UPDATE_USER = gql`
  mutation updateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        id
      }
    }
  }
`;

export const RiskQuestion = ({
  options,
  userId,
  onNext,
  stepLoading,
  question,
  workflowCompletion,
}: {
  options: any;
  userId: string;
  onNext: () => void;
  stepLoading: boolean;
  question: number;
  workflowCompletion?: any;
}) => {
  const [userData, setUserData] = useState<any>({
    riskQuestion1: null,
    riskQuestion2: null,
  });

  const { data, loading } = useQuery(FETCH_USER, {
    variables: { userId },
    fetchPolicy: 'no-cache',
  });

  const [updateUser, { loading: updateUserLoading }] = useMutation(
    UPDATE_USER,
    {
      context: {
        headers: getWorkflowCompletionHeaders(workflowCompletion),
      },
      onCompleted: () => {
        onNext();
      },
      variables: {
        input: {
          ...userData,
          userId,
        },
      },
    },
  );

  useEffect(() => {
    if (data) {
      setUserData({
        riskQuestion1: data.fetchUser.user.riskQuestion1 || undefined,
        riskQuestion2: data.fetchUser.user.riskQuestion2 || undefined,
      });
    }
  }, [data]);

  return (
    <RiskQuestionVisual
      question={question}
      options={options}
      userData={userData}
      updateUser={setUserData}
      continueFunc={updateUser}
      loading={loading || updateUserLoading || stepLoading}
      workflowCompletion={workflowCompletion}
    />
  );
};

export default RiskQuestion;
